<div  id="videoContainer" class="containerVideo" #myBounds>
  <div id="mutebtn" class="mute-button">
    @if (!isMutedParticipant && (participantConnectedInRoom && isZoom)) {
      <div id="hideMe">
        <span class="buttonMute"><i class="material-icons">mic</i>{{nameOfparticipant}} Microphone on</span>
      </div>
    }
    @if (isMutedParticipant && (participantConnectedInRoom && isZoom)) {
      <div>
        <span class="buttonMute"><i class="material-icons">mic_off</i> {{nameOfparticipant}} Microphone off</span>
      </div>
    }
  </div>
  <div class="row1" style="height: inherit;">
    <div class="conatainer-inner" style="height: inherit;">
      <div class="left" style="height: inherit;">
        <div id="share-screen" class="remote-video" #screenshare autoplay style="height: 90%; text-align: center; display: flex; align-items: center;">
          <video id="my-screen-share-content-video" style="width: 100%; display: none; height: 100%; object-fit: contain; max-width: 100%; max-height: 100%;"></video>
          <canvas width="1920" height="1080" style="display: none; width: 100%; height: 100%; object-fit: contain; max-width: 100%; max-height: 100%;" id="my-screen-share-content-canvas"></canvas>
          <canvas style="display: none; width: 100%; height: 100%; object-fit: contain; max-width: 100%; max-height: 100%;" id="users-screen-share-content-canvas"></canvas>
        </div>
      </div>
      <div class="right">
        <div class="local-videoTrack" id="local-videoTrack-container">
          <div ngDraggable (edge)="checkEdge($event)" [bounds]="myBounds" [inBounds]="inBounds" id="video-call-view-local">
            <div id="overlay"></div>
            <div id="myVideo" #localVideo autoplay muted></div>
            <video style="border: 1px solid white;background-color: black; display: none; " id="zoom-local"
            width="100%"></video>
            <canvas style="border: 1px solid white;background-color: black; display: none; " id="my-self-view-canvas"
            width="640" height="360"></canvas>
          </div>
        </div>
        <div [ngDraggable]="isScreenSharing || isParticipantScreenShareActive" (edge)="checkEdge($event)" [bounds]="myBounds" [inBounds]="inBounds"  class="remote-videoTrack" id="remote-videoTrack-container">
          <div id="overlayParticipant"></div>
          <div id="remote" class="remote-video shareScreen" #remoteVideo autoplay>
            <canvas id="participant-videos-canvas" width="1920" height="1080"></canvas>
          </div>
        </div>
      </div>
    </div>


    <div class="row2">
      <div class="container1">
        <div class="col3 button-group">
          <button id="muteButton" class="button" [ngClass]="{ 'muted': isMuted }"
            (click)="muteAndUnmuteAudio()" [disabled]="!isLocalVideoPresent">
            @if (isRetryingAudio) {
              <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
            }
            @if (!isRetryingAudio && !isMuted) {
              <i class="material-icons" aria-label="mute audio" >mic</i>
            }
            @if (!isRetryingAudio && isMuted) {
              <i class="material-icons" aria-label="unmute audio" >mic_off</i>
            }
          </button>
        </div>
        <div class="col3 button-group">
          <button id="videoButton" class="button" [ngClass]="{ 'video-disabled': isVideoDisabled }"
            (click)="muteAndUnmuteVideo()" [disabled]="!isLocalVideoPresent">
            <i class="material-icons" aria-label="mute video" [class.hidden]="isVideoDisabled">videocam</i>
            <i class="material-icons" aria-label="unmute video" [class.hidden]="!isVideoDisabled">videocam_off</i>
          </button>
        </div>
        <div class="col3 button-group">
          <button id="disconnectButton" [ngClass]="{'disabled-call-button': strictToDisconnectCall}"
            [disabled]="strictToDisconnectCall" class="button disconnect" (click)="disconnectFromZoomRoom()">
            <i class="material-icons">call_end</i>
          </button>
        </div>
        @if (toEnablePip()) {
          <div class="col3 button-group">
            <button id="videoButton" [ngClass]="{'disabled-call-button': strictToDisconnectCall}"
              [disabled]="strictToDisconnectCall" class="button" aria-label="close full screen" (click)="startPictureInPicture()">
              <span class="material-icons material-symbols-outlined">
                close_fullscreen
              </span>
            </button>
          </div>
        }
        @if (isPhoneJoined && isZoom) {
          <div class="col3 button-group">
            <button id="disconnectButton" class="button" aria-label="flip camera" (click)="switchCamera()">
              <i class="material-icons">flip_camera_android</i>
            </button>
          </div>
        }
        @if (isZoom) {
          <div class="col3 button-group">
            <button class="button" (click)="shareScreen()" [disabled]="isBottomPopupOpen">
              <span
                class="material-symbols-outlined"
                [title]="isScreenSharing ? 'Stop share' : 'Share screen'"
                [attr.aria-label]="isScreenSharing ? 'Stop share' : 'Share screen'">
              <!-- </span> -->
              {{ isScreenSharing ? 'stop_screen_share' : 'screen_share' }}
            </span>
          </button>
        </div>
      }

    </div>
  </div>
</div>
</div>
<!-- pre-join.component.html -->
<div class="body hide-scrollbar">
  @if (isTestVideoCall) {
    <div class="container">
      <h1>Get ready to join your {{oppositeRole}} {{channelName}}</h1>
      <div class="subtitle">Check your setup before you go live</div>
    <div class="status" [ngStyle]="isFirstToJoin ? 
    { 'background-color': '#2d2d2d', 'color': 'white' } : 
    { 'background-color': 'lightblue', 'color': 'blue' }">
        {{ isFirstToJoin
        ? 'You are the first to join'
        : 'Your ' + oppositeRole +' '+ channelName +' has already joined' }}
      </div>
      <div class="video-container">
        <div class="video-box">
          <div class="video-call-view">
            <!-- Keep both hosts in the DOM so Zoom can attach before async CD swaps @if. -->
            <video id="local-preview-video" autoplay muted playsinline
              [style.display]="!isBrowserSupportsVirtualBg && isTestCameraOn ? 'block' : 'none'"></video>
            <canvas id="local-preview-canvas" autoplay muted playsinline
              [style.display]="isBrowserSupportsVirtualBg && isTestCameraOn ? 'block' : 'none'"></canvas>
            @if (!isTestCameraOn) {
              <div class="center-content">
                <div class="avatar">{{initials}}</div>
                <div class="camera-status">Your camera is off</div>
              </div>
            }
            <!-- <p style="color: #4b0082; font-weight: bold;">Ready to join the session?</p> -->
          </div>
          <div class="controls">
            <div class="settings-container">
              <!-- Row 1: Speaker -->
              <div class="settings-row">
                <button [ngStyle]="isTestingMicrophone ? {'cursor': 'not-allowed', 'opacity': '0.6'} : {}"
                  [disabled]="isTestingMicrophone"
                  (click)="testSpeaker()"
                  class="icon-btn"
                  [ngStyle]="{ 'background': isTestingSpeaker ? 'blue' : '#2d2d2d' }">
                  <mat-icon matTooltip="Check your sound or change where you hear it">{{
                  isTestingSpeaker ? 'volume_up' : 'volume_off' }}</mat-icon>
                  <span class="icon-separator"></span>
                  <mat-icon class="margin-icon" matRipple matTooltip="Choose where the sound plays from"
                  [matMenuTriggerFor]="speakerMenu">more_vert</mat-icon>
                </button>
                <button class="action-btn" (click)="testSpeaker()"
                  [disabled]="isTestingMicrophone"
                  [ngStyle]="isTestingMicrophone ? {'cursor': 'not-allowed', 'opacity': '0.6'} : {}">
                  <mat-icon>volume_up</mat-icon>
                  {{ isTestingSpeaker === true ? 'Stop Speaker' : 'Check sound' }}
                </button>
              </div>
              <!-- Row 2: Microphone -->
              <div class="settings-row">
                <button [disabled]="isTestingSpeaker"
                  class="icon-btn"
                  (click)="toggleTestMic()"
                  [ngStyle]="isTestingSpeaker ? { 'cursor' : 'not-allowed' , 'opacity': '0.6'} : {}"
                  [ngStyle]="{ 'background': isTestMicOn ? 'green' : '#2d2d2d' }">
                  <mat-icon matTooltip="Tap to mute or unmute yourself">{{ isTestMicOn ? 'mic' :
                  'mic_off' }}</mat-icon>
                  <mat-icon class="margin-icon" matTooltip="Choose or test your mic"
                  [matMenuTriggerFor]="micMenu">more_vert</mat-icon>
                </button>
                <button class="action-btn" (click)="testMicrophone()"
                  [disabled]="isTestingSpeaker || !localAudioTrackInitlized"
                  [ngStyle]="isTestingSpeaker || !localAudioTrackInitlized ? { 'cursor' : 'not-allowed' , 'opacity': '0.6'} : {}">
                  <span>🎤</span>
                  {{ microPhoneTextContent }}
                </button>
              </div>
              <div class="settings-row">
                <span style="display: flex; align-items: center; width: 70%;">Your voice level</span>
                <div class="mic-controls">
                  <mat-icon>volume_up</mat-icon>
                  <div class="voice-meter" style="width: 90%;">
                    <input type="range" min="0" max="100" [value]="micInputLevel" class="no-drag" />
                  </div>
                </div>
              </div>
              <!-- Row 3: Camera -->
              <div class="settings-row">
                <button class="icon-btn" [ngStyle]="{ 'background': isTestCameraOn ? 'green' : '#2d2d2d' }">
                  <mat-icon (click)="toggleTestCamera()" matTooltip="Tap to turn your camera on or off">{{ isTestCameraOn
                  ? 'videocam' : 'videocam_off' }}</mat-icon>
                  <mat-icon class="margin-icon" matTooltip="Choose or test your camera"
                  [matMenuTriggerFor]="cameraMenu">more_vert</mat-icon>
                </button>
                <button (click)="switchToCameraList()" class="action-btn"> <mat-icon>videocam</mat-icon>Switch camera</button>
              </div>
            </div>
          </div>
        </div>
        <div class="footer">
          <button
            matTooltip="Ready? Tap to join your {{oppositeRole}}"
            class="join-btn"
            [disabled]="isJoinDelayActive || !isTestScreenReady"
            [ngClass]="{'disabled-call-button': isJoinDelayActive || !isTestScreenReady}"
            (click)="connectToZooRoom()">
            @if (!isJoinDelayActive && isTestScreenReady) {
              <span style="display: flex; align-items: center; justify-content: center; gap: 8px;">
                Join call
              </span>
            }
            @if (isJoinDelayActive) {
              <span style="display: flex; align-items: center; justify-content: center; gap: 8px;">
                <mat-spinner diameter="20" style="display: inline-block;"></mat-spinner>
                <span>Joining...</span>
              </span>
            }
            @if (!isTestScreenReady && !isJoinDelayActive) {
              <span style="display: flex; align-items: center; justify-content: center; gap: 8px;">
                <mat-spinner diameter="20" style="display: inline-block;"></mat-spinner>
                <span>Initializing...</span>
              </span>
            }
          </button>
          <button matTooltip="Tap to leave the call, you won't be able to join your {{oppositeRole}} on call" class="cancel-btn"
          (click)="cancelTestCall()">Cancel</button>
        </div>
      </div>
    </div>
  }
</div>

<!-- Speaker Options Menu -->
<!-- Menu -->
<mat-menu #speakerMenu="matMenu" class="speaker-menu">
  @for (option of speakerTestDevices; track i; let last = $last; let i = $index) {
    <div class="custom-menu-item" [matTooltip]="option.label"
      (click)="setSpeaker(option.deviceId)" [class.no-border]="last">
      <span class="menu-label">{{ option.label }}</span>
      @if (selectedTestSpeaker === option.deviceId) {
        <mat-icon class="tick-icon">check</mat-icon>
      }
    </div>
  }
</mat-menu>
<mat-menu #micMenu="matMenu" class="speaker-menu">
  @for (mic of microphoneTestDevices; track i; let last = $last; let i = $index) {
    <div class="custom-menu-item" [matTooltip]="mic.label"
      (click)="setMic(mic.deviceId)" [class.no-border]="last">
      <span class="menu-label">{{ mic.label || 'Microphone' }}</span>
      @if (selectedTestMic === mic.deviceId) {
        <mat-icon class="tick-icon">check</mat-icon>
      }
    </div>
  }
</mat-menu>
<mat-menu #cameraMenu="matMenu" class="speaker-menu">
  @for (camera of videoTestDevices; track i; let last = $last; let i = $index) {
    <div class="custom-menu-item" [matTooltip]="camera.label"
      (click)="setCamera(camera.deviceId, i)" [class.no-border]="last" [class.disabled-item]="selectedTestCamera === camera.deviceId">
      <span class="menu-label">{{ camera.label || 'Camera' }}</span>
      @if (selectedTestCamera === camera.deviceId) {
        <mat-icon class="tick-icon">check</mat-icon>
      }
    </div>
  }
</mat-menu>

<!-- Leave Conformation pop up -->
@if (isLeavePopUp) {
  <div class="dialog-container">
    <h2 class="dialog-title">Are you sure you want to leave the session?</h2>
    <p class="dialog-subtitle">
      You haven’t joined the call yet, but leaving now means you won’t meet your mentor.
    </p>
    <div class="dialog-illustration">
      <img src="../../../../assets/img/IntroSlide3.jpg" alt="Illustration" />
    </div>
    <p class="dialog-help">
      <strong>Need help?</strong> Check out the video FAQs in your project materials,
      or reach out to us via the support team chat.
    </p>
    <div class="dialog-actions">
      <button mat-raised-button color="warn" (click)="closeDialog()">Leave</button>
      <button mat-raised-button color="primary" style="background-color: green; color: white;"
      (click)="stay()">Stay</button>
    </div>
  </div>
}
<!-- <div>
<video id="my-self-view-video" width="1920" height="1080"></video>
<canvas id="my-self-view-canvas" width="1920" height="1080"></canvas>
</div> -->

<!-- Screen share consent pop up-->
@if (isBottomPopupOpen) {
  <div class="screen-sharing-banner">
    <span class="screen-sharing-banner-text">
      {{
      isSender
      ? (screenShareRecipientName
      ? ('videocalls.senderScreenShareConsentWithName' | translate:{ name: screenShareRecipientName })
      : ('videocalls.senderScreenShareConsent' | translate))
      : (screenShareRequesterName
      ? ('videocalls.screenShareConsentWithName' | translate:{ name: screenShareRequesterName })
      : ('videocalls.screenShareConsent' | translate))
      }}
    </span>
    <div class="buttons">
      @if (!isSender) {
        <button  class="stop-sharing-btn" (click)="sendScreenshareReceiverConsent()">{{'videocalls.allow' | translate }}</button>
      }
      <span (click)="denyScreenshareReceiverConsent()" class="hide-btn">{{ isSender ? ('videocalls.close' | translate) : ('videocalls.deny' | translate) }}</span>
    </div>
  </div>
}
